/* AI art for the teacher landing v2 (lead-owned; builders import, never edit).
   Every entry is either an imported, optimized image or null. When null, the
   consumer renders a CSS gradient fallback in the entry's hue, so the page always
   looks finished while the lead picks images from the Codex batches.

   Wallpapers follow the motion spec's hue order (W1 peach-gold, W2 mint, W3 sky,
   W4 violet, W5 coral). `glow` versions fade to pure white at every edge (hero
   frame=glow mode); `tile` versions fill the frame (frame=tile mode and the
   section tiles below the hero). Sources: scratch/codex/2026-09-29_landing-art-r1
   and _landing-art-r2-glows (Codex image_gen), resized to JPEG q80 / 384px PNG. Tiles use the *-soft versions (Sandy 2026-09-29: "more blurred"; 3-pass box blur via scratch/teacher-landing/soft-blur.cjs, saturated hues lifted toward white).
   W2 glow and W5 are placeholders until the matched set lands. */
import tileCoralDune from './tile-coral-dune-soft.jpg';
// The original mint mesh, unblurred: the exact tile Sandy liked ("I like the blurry one").
import tileMintMesh from './tile-mint-mesh.jpg';
import tileSkyLiquid from './tile-sky-liquid-soft.jpg';
import tileVioletSilk from './tile-violet-silk-soft.jpg';
import tileSunrise from './tile-sunrise-soft.jpg';
import tileViolet from './tile-violet-soft.jpg';
// violet-silk lifted 50% toward white (2026-09-30): the How-you-start step 2
// tile, as light as its mint and sky neighbors
import tileVioletLight from './tile-violet-light-soft.jpg';
import tileSky from './tile-sky-soft.jpg';
import tilePastel from './tile-pastel-soft.jpg';
import tileCoral from './tile-coral-soft.jpg';
// Matched glow set (landing-art-r3-matched): same aurora shape, one hue per step,
// edges verified pure white (255) after JPEG.
import glowW1 from './glow-w1-peach.jpg';
import glowW2 from './glow-w2-mint.jpg';
import glowW3 from './glow-w3-sky.jpg';
import glowW4 from './glow-w4-violet.jpg';
import glowW5 from './glow-w5-coral.jpg';

export const WALLPAPER = {
  w1: { tile: tileCoralDune, glow: glowW1, hue: '#FFB547', soft: '#FFE3A3' },
  w2: { tile: tileMintMesh, glow: glowW2, hue: '#3CCB8B', soft: '#C8F3DD' },
  w3: { tile: tileSkyLiquid, glow: glowW3, hue: '#3B9CFF', soft: '#CBE6FF' },
  w4: { tile: tileVioletSilk, glow: glowW4, hue: '#7B61FF', soft: '#DCD5FF' },
  w5: { tile: tileCoral, glow: glowW5, hue: '#FF7A8A', soft: '#FFD6DC' },
};

// Extra wallpapers for section tiles that are not tied to a hero step.
export const WALLPAPER_EXTRA = { pastel: tilePastel, violetWaves: tileViolet, violetLight: tileVioletLight, sky: tileSky, sunrise: tileSunrise };


